import { refs, domReady } from '../modules/utils.js';
import { onScroll, animate } from 'animejs';

class ScrollImages extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#init();
  }

  #init() {
    if (!this.refs.images?.length) return;

    this.refs.images.forEach((el) => {
      animate(el, {
        y: '-25rem',
        rotateX: '5deg',
        ease: 'inOutSine',
        autoplay: onScroll({
          enter: 'top+=25% top',
          leave: 'top+=10% bottom',
          sync: true,
          debug: false
        })
      });
    });
  }
}

customElements.define('scroll-images', ScrollImages);
